<div class="pdf-host">
  @if (safeHtml) {
    <iframe
      #frame
      class="form-frame"
      [srcdoc]="safeHtml"
      (load)="onFrameLoad()"
      data-testid="form-html"
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      title="Form 266"
    ></iframe>
  } @else {
    <div class="status" data-testid="form-empty">No form content</div>
  }
</div>
